import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout, firebase_update, firebase_update_device, firebase_get_device_log} from "./firebase";

import ChartData from "./ChartData";
import ChartData2 from "./ChartData2";

import moment from "moment-timezone";

const { faker } = require('@faker-js/faker');


function DeviceChart(props){
  //const r = '/device_logs/' + props.deviceId  + "/" + moment(props.date).format("yyyy") + "/" + (moment(props.date).format("MM")) + "/" + moment(props.date).format("DD") + "/";
  //console.log(r)

  //const [device_log_snapshot, loading_device_log, error_db] = useList(db.ref(r));
  //const [deviceInfo, setDeviceInfo] = useState(props.deviceInfo);
 
  useEffect(async () => {
    //console.log("DEVICE INFO FROM DEVICECHART :: " + props.deviceInfo.temperature.t1.hardware_status)
     
  }, [props.deviceInfo]);

  return (<div className="container" style={{marginTop: -10}}>
          {
            (moment(props.date).format("MM")==moment(props.enddate).format("MM")) ? 
              <ChartData 
                key={props.deviceInfo} 
                r={"device_logs/" + props.deviceId + "/" + moment(props.daterange[0].startDate).format("yyyy") + "/" + moment(props.daterange[0].startDate).format("MM")} 
                startyear={moment(props.daterange[0].startDate).format("yyyy")} 
                endyear={moment(props.daterange[0].endDate).format("yyyy")} 
                startmonth={moment(props.daterange[0].startDate).format("MM")} 
                endmonth={moment(props.daterange[0].endDate).format("MM")} 
                startdate={moment(props.daterange[0].startDate).format("DD")} 
                enddate={moment(props.daterange[0].endDate).format("DD")} 
                type={props.type} 
                deviceInfo={props.deviceInfo} /> : 
              <ChartData2 
                key={props.deviceInfo} 
                r={"device_logs/" + props.deviceId + "/" + moment(props.daterange[0].startDate).format("yyyy")} 
                startyear={moment(props.daterange[0].startDate).format("yyyy")} 
                endyear={moment(props.daterange[0].endDate).format("yyyy")} 
                startmonth={moment(props.daterange[0].startDate).format("MM")} 
                endmonth={moment(props.daterange[0].endDate).format("MM")} 
                startdate={moment(props.daterange[0].startDate).format("DD")} 
                enddate={moment(props.daterange[0].endDate).format("DD")} 
                type={props.type} 
                deviceInfo={props.deviceInfo}/>
          }
        </div>);
}

export default DeviceChart;
